<template>
  <div class="form-input-hint" v-if="hasError">
    <slot>{{ errorMessage }}</slot>
  </div>
</template>

<script>
const rules = [
  { name: 'required', message: 'Campo obrigatório' },
  { name: 'cnpj', message: 'CNPJ inválido' },
  { name: 'cpf', message: 'CPF inválido' },
  { name: 'email', message: 'E-mail inválido' },
  { name: 'cep', message: 'CEP inválido' },
  { name: 'phone', message: 'Telefone inválido' },
  { name: 'date', message: 'Data inválida' },
  {
    name: 'minLength',
    message: v => `Mínimo de ${v.$params.minLength.min} caracteres`,
  },
  {
    name: 'maxLength',
    message: v => `Máximo de ${v.$params.maxLength.max} caracteres`,
  },
];

export default {
  props: {
    validator: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hasError() {
      return this.validator.$error;
    },
    errorMessage() {
      const error = rules.find(({ name }) => this.validator[name] === false);

      if (error) {
        return typeof error.message === 'function'
          ? error.message(this.validator)
          : error.message;
      }

      return 'Campo inválido';
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/_variables.scss";
</style>
